import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Filial } from '../interfaces/filial';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';
import { CadArquivo } from '../interfaces/cad-arquivo';

@Injectable({
  providedIn: 'root'
})
export class FilialService {
  
  deleteImage(): Observable<any> {
    throw new Error('Method not implemented.');
  }

  readonly path = '/filial';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }

  saveOrUpdate(filial: Filial): Observable<any> {
    return this.http.put<Filial>(`${this.jwtAuthService.apiUrl + this.path}`, filial);
  }

  uploadCert(value: any): Observable<any> {
    return this.http.post(`${this.jwtAuthService.apiUrl + this.path}/cert/upload`, value);
  }

  downloadCert(): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/cert/download/`);
  }

  getFilial(id: number ): Observable<Filial> {
    return this.http.get<Filial>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getFilialSessao(): Observable<Filial> {
    return this.http.get<Filial>(`${this.jwtAuthService.apiUrl}/auth/me/filial`);
  }

  getFilialPage(page?: number, size?: number): Observable<PageResult<Filial>> {
    return this.http.get<PageResult<Filial>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getFilialPageSearch(page?: number, size?: number,  search?: string): Observable<PageResult<Filial>> {
    return this.http.get<PageResult<Filial>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}`);
  }

  testCert(uf = 'PR' ): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/cert/status?uf=${uf}`);
  }

  getCertValidity(): Observable<any> {
    return this.http.get(`${this.jwtAuthService.apiUrl + this.path}/cert/validade`);
  }

  uploadLogo(value: any): Observable<any> {
    return this.http.post(`${this.jwtAuthService.apiUrl + this.path}/upload/logo`, value);
  }

  getLogoUrl(base64?: boolean) {
    return `${this.jwtAuthService.apiUrl + this.path}/logo/${base64 ? 'base64/' : ''}`;
  }



}
